export const receiveContacts = contacts => {
  return {
    type: 'RECEIVE_CONTACTS',
    contacts
  }
}

export const selectContact = selectedId => {
  return {
    type: 'SELECT_CONTACT',
    selectedId
  }
}

export const deselectContact = deselectedId => {
  return {
    type: 'DESELECT_CONTACT',
    deselectedId
  }
}